// Vibrant palette used for poll option colours across Submit and Edit surfaces.
// Kept in one place so editors always see the same swatches and so listings /
// mini charts stay visually consistent with what an editor chose.
export const POLL_COLOR_PALETTE = [
  "#fc4707", // Brand orange (What Do We Want? accent)
  "#ff8a00", // Amber
  "#ffb300", // Saffron
  "#ffd60a", // Vivid yellow
  "#8ed973", // Fresh green
  "#22c55e", // Emerald
  "#00b894", // Mint
  "#14b8a6", // Teal
  "#06b6d4", // Cyan
  "#2a738f", // Steel blue
  "#3b82f6", // Royal blue
  "#6366f1", // Indigo
  "#8b5cf6", // Violet
  "#a02b93", // Magenta
  "#ec4899", // Pink
  "#f43f5e", // Rose
  "#ef4444", // Red
  "#1e293b", // Slate
];

// Return the palette colour for a given index, wrapping so we never run out.
export function paletteColor(idx) {
  const list = POLL_COLOR_PALETTE;
  return list[idx % list.length];
}
